import script from "./PaymentMethodSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodSelect.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodSelect.vue?vue&type=style&index=0&id=0f1fbdee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1fbdee"]])

export default __exports__